<template>
  <div>
    <v-card class="mx-auto" width="100vw" style="border:transparent" v-for="(item, index) in data.activity_logs_by_date" :key="index"
        outlined
    >
    <v-toolbar color="primary" 
        elevation="1"
        dark
        dense        
    >
        <v-toolbar-title>{{item.date}}</v-toolbar-title>
    </v-toolbar>
    <v-container fluid class="px-2" fill-width>
        <v-row dense v-for="(log, index) in item.logs" :key="index" >
            <v-col cols="4">
                {{formatDate(log.createdAt)}}
            </v-col >
            <v-col cols="4">
                {{log.user.first_name}} {{log.user.middle_name}} {{log.user.last_name}}
            </v-col>
            <v-col cols="4" v-dompurify-html="getStringfromHtml(log.description)">
                <!-- {{log.description}} -->
            </v-col>
        </v-row>
    </v-container>
    </v-card>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    data: Object,
  },
  methods: {
      formatDate(date){
          return moment(date).format('LLL')
      },
      getStringfromHtml(html){
          var txt = document.createElement("textarea");
          txt.innerHTML = html;
          return txt.value;
      },  
  }
};
</script>